import { get, post, put, deleteUrl, postUrl } from './index'

import base from './base'

const api = base + 'gbh-portal/'
const utility = base + 'gbh-portal/'
const solr = base + 'gbh-portal/'

export default {
    queryWebNewsList: (params) => {  //官网查询首页置顶新闻列表
        params.queryEn = localStorage.getItem('lang') === 'en'
        return post(api + 'webNews/webQueryTopList', params)
    },
    queryWebReleaseList: (params) => {  //官网查询发布列表
        return post(api + 'webRelease/webQueryList', params)
    },
    queryWebActivityList: (params) => {  //官网查询活动列表
        return post(api + 'webActivity/webQueryList', params)
    },
    getMeetingTime: (params) => {  //官网查询大会倒计时
        return get(api + 'webCommon/getMeetingTime', params)
    },
    getWebHomeExhibit: (params) => {  //官网查询专业展首页信息
        return get(api + 'webExhibit/getWebHomeExhibit', params)
    },
    getExhibitExhibitionList: (params) => {  //官网查询专业展知名展商
        return post(api + 'webExhibit/exhibitExhibitionList', params)
    },
    getWebQueryList: (params) => {  //官网查询新闻列表
        params.queryEn = localStorage.getItem('lang') === 'en'
        return post(api + 'webNews/webQueryList', params)
    },
    getWebDownload: (params) => {  //官网查询专业展资料下载
        params.queryEn = localStorage.getItem('lang') === 'en'
        return post(api + 'webDownload/webExhibitDataDownload', params)
    },
    getWebExhibitDirectory: (params) => {  //官网查询专业展展商名录列表
        params.queryEn = localStorage.getItem('lang') === 'en'
        return post(api + 'webExhibit/webExhibitDirectory', params)
    },
    getWebIconDownload: (params) => {  //官网查询图片图标
        return post(api + 'webDownload/webIconDownload', params)
    },
    getQueryExhibitDetail: (uuid) => {  //官网查询专业展信息
        return get(api + 'webExhibit/queryExhibitDetail/' + uuid)
    },
    getWebNewsDetail: (uuid) => {  //官网查询新闻详情
        return get(api + 'webNews/queryDetail/' + uuid)
    },
    getWeReleaseDetail: (uuid) => {  //官网查询发布详情
        return get(api + 'webRelease/queryDetail/' + uuid)
    },
    getWebActivityDetail: (uuid) => {  //官网查询活动详情
        return get(api + 'webActivity/queryDetail/' + uuid)
    },
    getWebExhibitNewsDetail: (uuid) => {  //官网查询专业展新闻详情
        return get(api + 'webExhibit/queryNewsDetail/' + uuid)
    },
    getWebExhibitForumDetail: (uuid) => {  //官网查询专业展论坛详情
        return get(api + 'webExhibit/queryForumDetail/' + uuid)
    },
    getExhibitionFunctionModule: (uuid) => {  //专业展-精彩瞬间下面那几个图标
        return get(api + 'webCommon/getExhibitionFunctionModule/' + uuid)
    },
    getHomeNavMenu: (uuid) => {  //官网导航栏
        return get(api + 'webCommon/getHomeNavMenu/' + uuid)
    },
    getSingleContent: (code) => {  //官网-单页内容
        return get(api + 'webCommon/getSingleContent/' + code)
    },
    getExhibitSingleContent: (params) => {  //专业展-单页内容
        return get(api + `webCommon/getExhibitSingleContent/${params.exhibitUuid}/${params.code}`)
    },
    getExhibitNavMenu: (params) => {  //查询专业展导航栏
        return get(api + `webCommon/getExhibitNavMenu/${params.exhibitUuid}/${params.code}`)
    },
    getWebMomentList: (params) => {  //官网查询专业展精彩瞬间列表
        return post(api + 'webExhibit/webMomentList', params)
    },
    getExhibitNewsList: (params) => {  //官网查询专业展新闻
        return post(api + 'webExhibit/exhibitNewsList', params)
    },
    getExhibitBannerList: (params) => {  //官网查询专业展banner
        return post(api + 'webExhibit/exhibitBannerList', params)
    },
    getExhibitExhibitionList: (params) => {  //官网查询专业展知名展商
        return post(api + 'webExhibit/exhibitExhibitionList', params)
    },
    getExhibitMediaList: (params) => {  //官网查询专业展合作媒体
        return post(api + 'webExhibit/exhibitMediaList', params)
    },
    getWebDataDownload: (params) => {  //展商服务-资料下载
        params.queryEn = localStorage.getItem('lang') === 'en'
        return post(api + 'webDownload/webDataDownload', params)
    },
    getWebOtherDataDownload: (params) => {  //下载中心-其他
        params.queryEn = localStorage.getItem('lang') === 'en'
        return post(api + 'webDownload/webOtherDataDownload', params)
    },
    getQueryForumList: (params) => {  //官网查询专业展专业展论坛列表
        return post(api + 'webExhibit/queryForumList', params)
    },
    getWebReportList: (params) => {  //查询官网展后报告列表
        return post(api + 'webReport/webReportList', params)
    },
    getWebPreviewList: (params) => {  //专业展-精彩瞬间下方小图标-展会预览
        return post(api + 'webExhibit/webPreviewList', params)
    },
    getEnrollList: (params) => {  //查询参展申请专业展
        return get(api + 'webExhibitApply/enrollList', params)
    },
    addWebExhibitApply: (params) => {  //参展申请
        return post(api + 'webExhibitApply/add', params)
    },
}




// WEBPACK FOOTER //
// ./src/api/li.js